import { Component, OnInit } from '@angular/core';
import { AppConfig } from 'src/app/app-config.module';
import { AppInsightsService } from 'src/app/services';
import { ErrorService } from 'src/app/services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit
{
  public title: string;
  public msg: string;

  private readonly errorService: ErrorService;
  private readonly appInsightsService: AppInsightsService;
  private readonly appConfig: AppConfig;

  constructor(errorService: ErrorService, appInsightsService: AppInsightsService, appConfig: AppConfig)
  {
    this.errorService = errorService;
    this.appInsightsService = appInsightsService;
    this.appConfig = appConfig;
  }

  public ngOnInit(): void
  {
    this.getError();
    const path = window.location.pathname;
    
    if(this.appConfig.production)
    {
      this.appInsightsService.logEvent('error-page', {'pathname': path});
    }
  }

  private getError(): void
  {
    const error = this.errorService.getErrorMsg();
    this.title = error.title;
    this.msg = error.msg;
  }

}
